// extracted by mini-css-extract-plugin
export var sliderRange = "_ln-2";
export var sliderRoot = "_ln-0";
export var sliderThumb = "_ln-3";
export var sliderTrack = "_ln-1";